import { render, staticRenderFns } from "./ApplicantSurveyFeedback.vue?vue&type=template&id=955fb060&"
import script from "./ApplicantSurveyFeedback.vue?vue&type=script&lang=js&"
export * from "./ApplicantSurveyFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports